"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mobile = void 0;
var _react = _interopRequireDefault(require("react"));
var _ActionLink = require("b2b-components/core/components/ActionLink");
var _Icon = require("b2b-components/core/components/Icon");
const Mobile = _ref => {
  let {
    crumbs,
    onCrumbClick
  } = _ref;
  const crumb = crumbs[crumbs.length - 2];
  if (!crumb) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_ActionLink.ActionLink, {
    iconName: _Icon.ICON_NAME.arrowLeft,
    iconSize: _Icon.ICON_SIZE.xsmall,
    href: crumb.url,
    onClick: () => onCrumbClick?.(crumb.url)
  }, crumb.title);
};
exports.Mobile = Mobile;
//# sourceMappingURL=Mobile.js.map